/* eslint-disable import/no-anonymous-default-export */
const d3 = require('d3')
const moment = require('moment');
const { parseDate } = require('../utils/formatters.js');
const { wrap, wrapByWidth } = require('../utils/shared-functions.js');
const { TRANSLATE_GENERAL_TAG } = require('../consts.js');
const TRANSLATE_TAG = 'charts.detections'
const margin = { top: 40, right: 30, bottom: 40, left: 80 };
const COLORS = {ecg: '#FF3359', ppg: '#A70322', pr: '#707070'}

exports.createDetectionsChart = function (detectionsData, onClick, width, height, translate) {
  const {start, end, detections, detectionsKeys} = detectionsData

  const getYAxisTicks = () => {
    const _yAxisTicks = []
    let tempDetectionType;
    detectionsKeys.map(d => {
      if(d.detection_type !== tempDetectionType){
        tempDetectionType = d.detection_type;
        _yAxisTicks.unshift({isDivider: true, type: tempDetectionType})
      }
      _yAxisTicks.unshift(d)
    })
    _yAxisTicks.unshift({isDivider: true})
    return _yAxisTicks
  }

  const yAxisTicks = getYAxisTicks()

  const detectionsKeysIndexes = {}//for the values y position
  yAxisTicks.map((d, i) => detectionsKeysIndexes[d.typeKey] = i)
  
  const x = d3.scaleBand()
    .domain(d3.utcDay.range(moment.utc(start).valueOf(), moment.utc(end).valueOf() + 1))
    .range([margin.left, width - margin.right])
    .padding(0.4);

  const y = d3.scaleLinear()
    .domain([0, yAxisTicks.length-1])
    .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g.attr('transform', `translate(0,${height - margin.bottom})`)
      .call(d3.axisBottom(x)
        .tickValues(d3.utcDay.every(1).range(moment.utc(start).valueOf(), moment.utc(end).valueOf() + 1))
        .tickFormat((d) => moment.utc(d).format('ddd DD'))
        .tickSize(0)
      )
      .call((g) =>
        g.selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g.attr('transform', `translate(${margin.left},0)`)
      .call(d3.axisLeft(y)
        .ticks(yAxisTicks.length-1)
        .tickFormat((d) => yAxisTicks[d]?.type)
        .tickSize(0)
        .tickPadding(10)
      )
      .call((g) =>
        g.selectAll('.tick text') // Select the text elements of ticks
          .attr('fill', (d) => COLORS[yAxisTicks[d]?.detection_type])
          .attr('font-size', '13px')
      )
      .call((g) =>
        g.selectAll('.tick line') // Select the line elements of ticks
          .clone()
          .attr('stroke-opacity', (d) => yAxisTicks[d]?.isDivider ? 1 : 0.2)
          .attr('x2', width - margin.left - margin.right)
      )

      //adding section title
      .call((g) => g.selectAll('.tick')
        .filter((d) => (yAxisTicks[d]?.isDivider && yAxisTicks[d]?.type))
        .append('rect')
        .attr('x', 0)
        .attr('y', -10)
        .attr('width', 150)
        .attr('height', 20)
        .attr('fill', '#fff')
        .style("stroke", '#000')
        .style("stroke-width", 1)
      )
      .call((g) => g.selectAll('.tick')
        .filter((d) => (yAxisTicks[d]?.isDivider && yAxisTicks[d]?.type))
        .append('text')
        .attr('x', 10)
        .attr('y', 5)
        .attr('class', 'exclude-wrap')
        .attr('fill', 'black')
        .style('font-size', '15px')
        .attr('direction', 'rtl')
        .text((d) => translate ? translate(`${TRANSLATE_TAG}.${yAxisTicks[d]?.type}_legend`) : `${yAxisTicks[d]?.type} detections`)
      )
      //end adding section title
      .call((g) => g.select('.domain').remove());

  const svg = d3
    .create('svg')
    .attr('width', width)
    .attr('height', height);

  svg.append('g').call(xAxis).selectAll('.tick text').call(wrap, x.bandwidth());
  svg.append('g').call(yAxis).selectAll('.tick text').call(wrapByWidth, margin.left);

  const xAxisLabelDate = svg
    .append('text')
    .attr('x', margin.left - 20)
    .attr('y', height - margin.bottom + 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.general_words.date`) : 'Date');

  const xAxisLabelDay = svg
    .append('text')
    .attr('x', margin.left - 20)
    .attr('y', height - margin.bottom + 33)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.general_words.day`) : 'Day');

  const g = svg
  .append('g')
  .selectAll('g')
  .data(detections)
  .join('g')
  .attr('transform', (d) => `translate(${x(parseDate(d.date)) + x.bandwidth() / 2},0)`);

  const candleGroup = g
    .append('g')
 
  const valueCircle = candleGroup
    .append('circle')
    .attr('r', 10)
    .attr('cy', (d) => y(detectionsKeysIndexes[d.typeKey]))
    .attr('stroke-width', 1)
    .attr('fill', 'white')
    .attr('stroke', (d) => COLORS[d.detection_type])
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));
    
    const valueText = candleGroup
    .append('text')
    .attr('text-anchor', 'middle')
    .attr('dy', (d) => y(detectionsKeysIndexes[d.typeKey])+3)
    .style('font-size', '11px')
    .attr('font-weight', '400')
    .append('tspan')
    .attr('font-family', 'roboto')
    .text((d) => d.timesPerDay)
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const gLegend = svg.append('g')
  .attr('transform', `translate(${width - margin.right}, ${margin.top - 25})`)
  .attr('direction', 'rtl');
 
  const episodesNumLegend = gLegend
  .append('circle')
  .attr('cx', -173)
  .attr('cy', margin.top - 31)
  .attr('r', 9)
  .attr('stroke-width', 2)
  .attr('fill', 'white')
  .attr('stroke', '#777B7F');

  const episodesNumLegendPlaceHolder = gLegend
    .append('text')
    .attr('x', -170)
    .attr('y', margin.top - 26)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('#');
     
  const episodesNumLegendText = gLegend
    .append('text')
    .attr('x', 0)
    .attr('y', margin.top - 25)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_TAG}.num_legend`) : 'Number of episodes');
  
  return svg.node();

}

